import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const EnquiryApi = createApi({
  reducerPath: "EnquiryApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["ENQUIRYAPI"],
  endpoints: (build) => ({
    getEnquiry: build.query({
      query: ({ page, status }) => ({
        url: `/enquiry?page=${page}&status=${status}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["ENQUIRYAPI"],
    }),

    getEnquiryById: build.query({
      query: ({ id }) => ({
        url: `/enquiry/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["ENQUIRYAPI"],
    }),

    editEnquiry: build.mutation({
      query: ({ id, data }) => ({
        url: `/enquiry/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["ENQUIRYAPI"],
    }),

    addEnquiry: build.mutation({
      query: ({ data }) => ({
        url: `/enquiry`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["ENQUIRYAPI"],
    }),

    deleteEnquiry: build.mutation({
      query: ({ id }) => ({
        url: `/enquiry/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["ENQUIRYAPI"],
    }),
  }),
});

export const {
  useGetEnquiryQuery,
  useGetEnquiryByIdQuery,
  useEditEnquiryMutation,
  useAddEnquiryMutation,
  useDeleteEnquiryMutation,
} = EnquiryApi;
